module.exports = __webpack_public_path__ + "static/media/flower_open_graph.ade0bb68.jpg";